// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-layout{background:-webkit-radial-gradient(50% 20%,circle,rgba(var(--swap-color),.06) 0,transparent 40%);background:-o-radial-gradient(50% 20%,circle,rgba(var(--swap-color),.06) 0,transparent 40%);background:radial-gradient(circle at 50% 20%,rgba(var(--swap-color),.06) 0,transparent 40%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
